import { Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';

export const videoCustomFields = [
  {
    name: 'videoSrc',
    type: 'string',
    helperText:
      'The URL of the video source. This can be a direct link to a video file or a platform like YouTube or Vimeo.',
  },
  imageField('thumbnail'),
] as const satisfies DeepReadonly<Input[]>;

const videoCustomConfig = {
  name: 'VideoCustom',
  inputs: videoCustomFields,
  override: true,
};

export type VideoCustomConfigProps = GenerateBuilder<typeof videoCustomFields>;

export default videoCustomConfig;
